import React from 'react';
import { useTranslation } from 'react-i18next';
import { useProgramPanel } from 'contexts/programPanelContext';
import { Program } from 'types/Program';
import { Panel, PanelItem } from '../../partials/panel';

type ProgramStatusProps = {
	readOnly?: boolean;
	programData: Program;
};

export const ProgramStatus = ({ readOnly = false, programData }: ProgramStatusProps) => {
	const { t } = useTranslation();
	const { panelPath } = useProgramPanel();

	const programName = programData?.name || '';
	const programUrl = `${process.env.REACT_APP_FRONT_URL}/${programName}`;

	return (
		<Panel
			title={t('programPanel.dashboard.status.title')}
			staticEdit={!readOnly ? { pathname: `/${panelPath}/config` } : undefined}
		>
			<>
				<PanelItem
					title={t('programPanel.dashboard.status.programNameDescription', {
						program: programData?.displayName,
						organization: programData?.organization?.displayName,
					})}
					value={programData?.organization?.displayName}
					transformValue={() => ''}
				/>
				<PanelItem
					title={t('programPanel.dashboard.status.programIsActive')}
					type="boolean"
					value={!programData?.finished}
					transformValue="active/unactive"
					inputCheckboxProps={{ invertValue: true }}
				/>
				<PanelItem
					title={t('programPanel.dashboard.status.programUrlAddress')}
					value={programUrl}
					transformValue={({ value }) => (
						<a href={value} target="_blank" rel="noreferrer" className=" underline">
							{value}
						</a>
					)}
				/>
				<PanelItem
					title={t('programPanel.dashboard.status.endDate')}
					value={programData?.endDate}
					type="date"
					clearable
					transformValue="date-only"
					withEmptyText
					bold
				/>
			</>
		</Panel>
	);
};
